import { addModal } from 'modules/messageSystem/actions/addModal';
import { addToast } from 'modules/messageSystem/actions/addToast';
import mediaStatus from 'modules/appointmentInfo/constants/mediaStatus';
import { MODAL_UPLOAD_META_FAILED } from 'modules/messageSystem/constants/modalCodes';

import createAction from './';


export const EDIT_FILE_NAME = createAction('EDIT_FILE_NAME');
export const CONSULTATION_MEDIA_DELETE_FROM_CHAT = createAction('CONSULTATION_MEDIA_DELETE_FROM_CHAT');
export const GET_CURRENT_CONSULTATION_MEDIA_FROM_CHAT = createAction('GET_CURRENT_CONSULTATION_MEDIA_FROM_CHAT');

export const onFileMetaDataUpdates = ({ err, data }) => (dispatch, getState) => {
  if (err) throw (err);

  const { fileUpdate } = data;

  const { status, comment, metaDataId } = fileUpdate;
  const state = getState();
  const { fileMetaDataList } = state.appointmentInfo.patientMedia;
  const fileAlreadyExist = fileMetaDataList.some(media => media.metaDataId === metaDataId);

  switch (true) {
    case (status === mediaStatus.UPLOADED && fileAlreadyExist):
      return dispatch({
        type: EDIT_FILE_NAME,
        payload: fileUpdate,
      });

    case (status === mediaStatus.UPLOADED):
      dispatch({
        type: GET_CURRENT_CONSULTATION_MEDIA_FROM_CHAT,
        payload: fileUpdate,
      });

      dispatch(addToast('success', 'file-approved-toast', {
        id: 'schedule.patientInfoTab.media.approved',
        defaultMessage: '** The file uploaded was approved. It can be viewed on both sides now.',
      }));
      return;

    case (status === mediaStatus.DELETED):
      return dispatch({
        type: CONSULTATION_MEDIA_DELETE_FROM_CHAT,
        meta: { metaDataId: fileUpdate.metaDataId },
      });

    case (status === mediaStatus.REJECTED):
      dispatch({
        type: GET_CURRENT_CONSULTATION_MEDIA_FROM_CHAT,
        payload: fileUpdate,
      });

      dispatch(addModal({
        testId: 'file-not-approved-modal',
        typeId: MODAL_UPLOAD_META_FAILED,
        preventClosingWhenDismiss: true,
        canAddDuplicate: false,
        isForce: true,
        bodyValues: { fileName: comment },
      }));

      dispatch(addToast('failure', 'file-not-approved-toast', {
        id: 'schedule.patientInfoTab.media.notApproved',
        defaultMessage: '** The file you uploaded is not approved.',
      }));
      break;

    default:
      break;
  }
};
